exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._1DdwIh7kph-Q3pth1fEhOv{margin-bottom:10px;margin-top:-8px}", ""]);

// exports
exports.locals = {
	"appearanceWrapper": "_1DdwIh7kph-Q3pth1fEhOv"
};